module.exports = __webpack_public_path__ + "img/md_flow02-s.1ac37482.png";